import { render, staticRenderFns } from "./splashsync.vue?vue&type=template&id=8d8a293e&scoped=true"
import script from "./splashsync.vue?vue&type=script&lang=js"
export * from "./splashsync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8a293e",
  null
  
)

export default component.exports